// 从当前路径获取参数
export function getParameterByName(inputName, url = window.location.href) {
  const name = inputName.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


// 获取seach参数obj
function getSearchParam() {
  const { search } = location; // 获取search中"?"符后的字串
  const theRequest = {};
  if (search.indexOf('?') !== -1) {
    const str = search.substr(1);
    const strs = str.split('&');
    strs.forEach((str) => {
      const splitArr = str.split('=');
      theRequest[splitArr[0]] = unescape(splitArr[1]);
    });
  }
  return theRequest;
}

// 过滤url中的key
export function getFilterSearch(filter: string[]): string {
  const searchParams = getSearchParam(); // 获取searchObj
  // 过滤filter中的key 用&拼接
  const search = Object.keys(searchParams).filter(key => filter.indexOf(key) === -1)
    .map(key => `${key}=${searchParams[key]}`)
    .join('&');
  return search ? `?${search}` : '';
}

